import { writable } from "svelte/store";
import { newSensorTempretureObservable } from "../commonRequests";
const activeChannels = {};
export function parseTempretureMsg(parsedMsg) {
    const sensorId = parsedMsg.sensorID;
    const value = parsedMsg.value;
    const timestapm = parsedMsg.timeStamp;
    // if (activeChannels.some(channal => channal.forId === sensorId)){
    if (activeChannels[sensorId]) {
        if (activeChannels[sensorId].timestamp < timestapm) {
            // console.log('TEMP IN:', parsedMsg)
            activeChannels[sensorId].obs.set([timestapm, value]);
        }
    }
    else {
        setNewChannal(sensorId);
        activeChannels[sensorId].obs.set([timestapm, value]);
    }
}
export function setNewChannal(id) {
    activeChannels[id] = {
        timestamp: 0,
        obs: writable([new Date().getTime(), NaN])
    };
}
export function registerTempretureActiveChannal(id, run) {
    // console.log("[INFO - lisening for probe]:", id)
    if (!activeChannels[id]) {
        setNewChannal(id);
    }
    return activeChannels[id].obs.subscribe(run);
}
function init() {
    newSensorTempretureObservable.subscribe(msg => {
        if (msg) {
            parseTempretureMsg(msg);
        }
    });
}
init();
